import { BaseModel } from '@/api/base-model'
import { StatusReasonAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { Pipeline } from '@/api/model/pipeline'

export class StatusReason extends BaseModel<StatusReason> {
    protected collectionName = StatusReasonAPI.collectionName

    constructor(
        public company: Company|null,
        public pipeline: Pipeline|null,
        public phases: PipelinePhase[],
        public id: string,
        public status: string,
        public name: string,
        public active: boolean,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): StatusReason {
        if (data === null || typeof data === 'string' || data instanceof StatusReason) {
            return data
        }

        return new StatusReason(
            data.company ? Company.fromData(data.company) : null,
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            Object.values(data.phases || {}).map(entry => PipelinePhase.fromData(entry)).sort((a, b) => a.compareTo(b)),
            data.id,
            data.status,
            data.name,
            data.active,
            data.createdAt,
            data.updatedAt,
        )
    }
}
